const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export async function fetchPublicQuestion(id) {
  if (!API_BASE) {
    throw new Error('API URL is not configured');
  }
  const res = await fetch(`${API_BASE}/api/public/questions/${id}`, {
    method: 'GET',
    credentials: 'omit',
    headers: { Accept: 'application/json' },
  });
  if (res.status === 404) return null;
  if (!res.ok) {
    throw new Error(`Could not load question (${res.status})`);
  }
  return res.json();
}
